import React, { useMemo, useState, useEffect } from "react";
import { IoCloseCircle } from "react-icons/io5";
import { useAuth } from "../../../../../hooks/useAuth";
import { roles } from "../../../../../constants/roles";
import { PrimaryButton } from "../../../../../components/primary/PrimaryButton";
import { FaArrowLeft, FaTimes } from "react-icons/fa6";
import zihuaLogo from "../../../../../assets/home/images/logo-fuerza-migrante.png";
import { useWindowWidth } from "../../../../../hooks/useWindowWidth";

const Banner = () => {
  return (
    <div
      className="max-md:hidden flex flex-col items-center bg-white p-2 rounded-lg mb-3 opacity-90"
      style={{
        background: "linear-gradient(90deg, rgba(250, 250, 250, 0.99) 0%, rgba(167, 234, 241, 0.99), rgba(255, 255, 255, 0.98) 100.01%)",
        border: "2px solid #2783b3",
      }}
    >
      <div className="flex flex-col items-center mb-2">
        <h3 className="label-details m-0">¿Eres miembro de Fuerza Migrante?</h3>
        <h3 className="label-details m-0">Tenemos un descuento</h3>
        <h3 className="label-details">especial para ti.</h3>
      </div>
      <img className="w-29 h-14" src={zihuaLogo} alt="Fuerza Migrante" />
    </div>
  );
};

const DetailsCard = ({
  children,
  position,
  onClose,
  onGoBack,
  submit,
  land,
  clusterId,
}) => {
  const { user } = useAuth();
  const { width } = useWindowWidth();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(width < 768);
  }, [width]);

  const responsiveRight = useMemo(() => {
    if (width < 510) {
      return "435px";
    }
    if (width < 650) {
      return "390px";
    }
    if (width < 794) {
      return "290px";
    }
    if (width < 880) {
      return "220px";
    }
    if (width < 995) {
      return "170px";
    }
    if (width < 1126) {
      return "120px";
    }
    return "50px";
  }, [width]);

  const renderContent = () => (
    <>
      {clusterId === 1 ? <Banner /> : null}
      <div
        style={{
          backgroundColor: "white",
          width: isMobile ? "100%" : "340px",
          borderRadius: "10px",
          opacity: "0.9",
          border: isMobile && "2px solid #2783b3"
        }}
      >
        <div
          className="sticky flex justify-between modal-header"
          style={{
            height: "50px",
            padding: "10px",
            background: "linear-gradient(90deg, rgba(5, 140, 191, 0.32) 0%, rgba(65, 207, 227, 0.32) 100.01%)",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          }}
        >
          <div className="modal-title pl-3">Detalles</div>
          <button onClick={() => onClose?.()}>
            {/* {isMobile ? (
              <FaArrowLeft className="text-2xl text-[#0096B3]" />
            ) : ( */}
              <IoCloseCircle
                color="#0096B3"
                fill="#0096B3"
                className="text-2xl cursor-pointer"
              />
            {/* )} */}
          </button>
        </div>
        {children}
      </div>
      <div className={`flex flex-col items-end ${isMobile ? 'p-4' : 'mr-4'} gap-2 mt-0`}>
        {!user && (
          <PrimaryButton style={{ minWidth: "max-content" }} className="px-1 text-[#000] mt-3">
            {"CONTINUAR CON EL PROCESO"}
          </PrimaryButton>
        )}
        {user &&
          land?.status === "on_sale" &&
          (user.user.roles[0].name.toLowerCase() === roles.SELLER ||
            user.user.roles[0].name.toLowerCase() === roles.COORDINATOR ||
            user.user.roles[0].name.toLowerCase() === roles.ADMIN ||
            user.user.roles[0].name.toLowerCase() === roles.SUPER_ADMIN ||
            user.user.roles[0].name.toLowerCase() === roles.ORGANIZATION ||
            user.user.roles[0].name.toLowerCase() === roles.CLIENT) && (
            <PrimaryButton
              className="px-1 text-[#000] mt-3"
              style={{
                minWidth: "210px",
                fontWeight: "500",
                borderRadius: "3px",
              }}
            >
              {"Seleccionar"}
            </PrimaryButton>
          )}
        <PrimaryButton
          className="flex flex-row items-center text-[#0195B2] mt-2 bg-[#E1EAED] text-[13px] py-1 px-2"
          variant="inner"
          style={{
            borderRadius: "3px",
          }}
          onClick={onGoBack}
        >
          <FaArrowLeft size={20} className="mr-2" />{" "}
          <p className="m-0 p-0">REGRESAR</p>
        </PrimaryButton>
      </div>
    </>
  );

  if (isMobile) {
    return (
      <div className="fixed inset-0 z-50 bg-black bg-opacity-75 max-md:overflow-y-auto">
        <div className="min-h-full flex flex-col p-4">
          <form onSubmit={submit} className="flex-1 flex flex-col">
            {renderContent()}
          </form>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit}>
      <div
        style={{
          top: position.top,
          right: responsiveRight,
          height: "100%",
          position: "absolute",
        }}
      >
        {renderContent()}
      </div>
    </form>
  );
};

export default DetailsCard;